import { useState } from 'react'

import type { SubscriptionBoxHistories } from '@lib/types/subscription-box'

import MonthlyBoxOrderCard from './MonthlyBoxOrderCard'
import MonthlyBoxOrderModal from './MonthlyBoxOrderModal'

type MonthlyBoxOrdersListProps = {
	orders: SubscriptionBoxHistories
}
export default function MonthlyBoxOrdersList({ orders }: MonthlyBoxOrdersListProps) {
	const [activeModalOrder, setActiveModalOrder] = useState<string | null>(null)

	const openOrderModal = (orderId: string) => {
		setActiveModalOrder(orderId)
	}

	const closeModal = () => {
		setActiveModalOrder(null)
	}

	// Sort the orders based on createdAt
	const sortedOrders = [...orders].sort((a, b) => {
		const dateA = new Date(a.createdAt).getTime()
		const dateB = new Date(b.createdAt).getTime()

		return dateB - dateA
	})

	return (
		<>
			<div className="w-full col-span-2 py-8 lg:pl-8">
				<ul className="grid gap-6 lg:grid-cols-2 lg:gap-8">
					{sortedOrders.map((order) => (
						<li key={order?.fulfillmentOrderId}>
							<MonthlyBoxOrderCard order={order} openOrderModal={openOrderModal} />
						</li>
					))}
				</ul>
			</div>

			{sortedOrders?.map((order) => (
				<MonthlyBoxOrderModal
					order={order}
					activeOrder={activeModalOrder}
					closeModal={closeModal}
					key={order?.fulfillmentOrderId}
				/>
			))}
		</>
	)
}
